import { Fragment, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useAuthorized from "../../hook/useAuthorized";
import Skeleton from "react-loading-skeleton";
import useFetch from "../../hook/useFetch";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../store/notification-slice";
import { userActions } from "../../store/user-slice";

export default function AdminLayout() {
  const { isAdmin } = useAuthorized();
  let navigate = useNavigate();
  const { get } = useFetch();
  const dispatch = useDispatch();
  const [twoFactorReady, setTwoFactorReady] = useState(false);

  useEffect(() => {
    if (isAdmin !== null) {
      if (!isAdmin) {
        navigate("/401");
      }
    }
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin) return;
    get("/admin/2fa", null, () => {
      dispatch(userActions.setUser(null));
      navigate("/login");
    }, status => {
      if (!status.verified) {
        navigate(status.configured ? "/2fa/challenge" : "/2fa/setup");
        return;
      }
      setTwoFactorReady(true);
    });
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin || !twoFactorReady) return;
    get("/admin/payment/rollback-requests", null, null, (requests) => {
      if (requests.length > 0) {
        dispatch(notificationActions.setNotification({
          message: `${requests.length} refund request${requests.length === 1 ? "" : "s"} pending. Open Refund requests to review.`,
          status: false,
        }));
      }
    });
  }, [isAdmin, twoFactorReady]);

  if (isAdmin === null || (isAdmin && !twoFactorReady)) {
    return <Skeleton count={50} />;
  }

  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
}
